import React from 'react';
import { DonateForm } from 'components/layout/forms';
import { PageWrapper2 } from 'components/modules/Wrapper2';
// import { home } from 'assets/images';
function DonateView() {
	return (
		<div className='bg-[#0E1022]'>
			<PageWrapper2>
				<div>
					<DonateForm />
				</div>
			</PageWrapper2>
		</div>
	);
}

export default DonateView;
